export enum LoanPurpose {
  DebtConsolidation = 'Debt consolidation',
  EducationalFees = 'Educational fees',
  Holiday = 'Holiday',
  HomeImprovements = 'Home improvements',
  LeaseExtension = 'Lease extension',
  Other = 'Other',
  PropertyPurchaseOrDeposit = 'Property purchase / Deposit',
  PurchaseEquity = 'Purchase equity',
  VehiclePurchase = 'Vehicle purchase',
  Wedding = 'Wedding',
}

export enum RepaymentType {
  CapitalAndRepaymentOnly = 'Capital and repayment only',
}

export type LoanDetails = {
  id: string,
  loanPurpose: (keyof typeof LoanPurpose)[],
  loanPurposeDetails: string,
  loanAmount: number,
  repaymentType: keyof typeof RepaymentType,
  grossLoanAmount: number,
  isExistingCustomer: boolean,
  term: number,
  isConsolidateExistingLoan: boolean,
  outstandingCurrentBalance: number,
  estimatedRedemptionAmount: number,
  fees: {
    BrokerFee: {
      id: string,
      fee: number,
      isAddToLoan: boolean,
    },
    ValuationFee: {
      id: string,
      fee: number,
      isAddToLoan: boolean,
    },
    AdviceFee: {
      id: string,
      fee: number,
      isAddToLoan: boolean,
    },
    LenderFee: {
      id: string,
      fee: number,
      isAddToLoan: boolean,
    },
    FeesToBePaidUpFront: {
      id: string,
      fee: number,
      isAddToLoan: boolean,
    },
  },
}
